import { createStyles } from 'antd-style'

import { pretty } from '@eastcoal/common/utils/decimal'

import { AccountStatisticItemProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: token.paddingXS,
    textAlign: 'center'
  },
  value: {
    fontSize: token.fontSizeHeading3
  },
  label: {
    color: token.colorTextLabel
  }
}))

export const AccountStatisticItem = ({
  className,
  style,
  label,
  value,
  extra
}: AccountStatisticItemProps) => {
  const { cx, styles } = useStyles()

  return (
    <div className={cx(styles.item, className)} style={style}>
      <span className={styles.value}>{pretty(value)}</span>
      <span className={styles.label}>{label}</span>
      {extra}
    </div>
  )
}
